var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-center m-t-10",attrs:{"id":"wxframe"}})}
var staticRenderFns = []

export { render, staticRenderFns }